/* @flow */

import type { $HereMapsTheme } from './HereMapsThemes';
import Globals from '../../../constants/Globals';

export function getHereMapsTilesURL(
  marketCode: string,
  language: string = Globals.DEFAULT_HERE_MAPS_LANGUAGE,
  theme: $HereMapsTheme = Globals.DEFAULT_HERE_MAPS_THEME
): string {
  switch (marketCode.toUpperCase()) {
    case 'KR':
      return buildHereMapsTilesURLKorea(Globals.HERE_MAPS_TILES_URL.KR_PROD, false, language, theme);
    default:
      return buildHereMapsTilesURL(Globals.HERE_MAPS_TILES_URL.WORLD_WIDE, true, language, theme);
  }
}

function getHereMapsLoadBalancingServerIndex(): string {
  const min = 1;
  const max = 4;
  return (Math.floor(Math.random() * (max - min + 1)) + min).toString();
}

function buildHereMapsTilesURL(
  baseURL: string,
  applyLanguage: boolean,
  language: string,
  theme: $HereMapsTheme
): string {
  const config = {
    baseURL: baseURL.replace('{serverIndex}', getHereMapsLoadBalancingServerIndex()),
    path: 'maptile/2.1',
    resource: 'maptile',
    mapVersion: 'newest',
    scheme: String(theme),
    zoom: '{z}',
    column: '{x}',
    row: '{y}',
    size: '256',
    format: 'png8',
  };

  return `${ config.baseURL }/${ config.path }/${ config.resource }/${ config.mapVersion }/${ config.scheme }/` +
    `${ config.zoom }/${ config.column }/${ config.row }/${ config.size }/${ config.format }` +
    `?apiKey=${ String(process.env.HERE_MAPS_API_KEY) }` +
    (applyLanguage && `&lg=${ language || Globals.DEFAULT_HERE_MAPS_LANGUAGE }` || '');
}

function buildHereMapsTilesURLKorea(
  baseURL: string,
  applyLanguage: boolean,
  language: string,
  theme: $HereMapsTheme,
): string {
  const config = {
    baseURL: baseURL.replace('{serverIndex}', getHereMapsLoadBalancingServerIndex()),
    path: 'maptile/2.1',
    resource: 'maptile',
    mapVersion: 'newest',
    scheme: String(theme),
    zoom: '{z}',
    column: '{x}',
    row: '{y}',
    size: '256',
    format: 'png8',
  }

  return (
    `${config.baseURL}/${config.path}/${config.resource}/${config.mapVersion}/${config.scheme}/` +
    `${config.zoom}/${config.column}/${config.row}/${config.size}/${config.format}` +
    `?app_id=Ear0VRMz4nV8YBtgwF4D` +
    `&app_code=1IKMeASqkmiJHWCi42oSvg` +
    (applyLanguage ? `&lg=${language}` : ``)
  )
}
